/*
* @描述: 添加成员
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/14 10:39
*/
<template>
  <van-popup v-model.sync="dialogVisible"
             :style="{ width: '100%',height: '100%' }">
    <van-nav-bar
        left-arrow
        left-text="返回"
        right-text=""
        title="添加团队成员"
        @click-left="handleDialogClose"/>
    <van-form ref="teamMembersAddForm"
              input-align="right"
              label-width="4em">
      <van-field :rules="teamMembersAddFormRules.member_uid"
                 :value="teamMembersAddForm.member_user"
                 error-message-align="right"
                 is-link
                 label="选择成员"
                 name="member"
                 placeholder="请选择成员"
                 readonly
                 required
                 @click="handleClickSelectMember">
      </van-field>
      <van-field label="权限类型" name="auth">
        <template #input>
          <van-radio-group v-model="teamMembersAddForm.auth" direction="horizontal">
            <van-radio :name="1">只读</van-radio>
            <van-radio :name="2">读写</van-radio>
          </van-radio-group>
        </template>
      </van-field>
    </van-form>
    <div style="margin: 16px;">
      <van-button block native-type="submit" round type="info" @click="handleDialogConfirm">提交</van-button>
    </div>
    <!--联系人组件弹窗-->
    <van-overlay v-if="showContactPicker"
                 :custom-style="{background: 'rgba(0, 0, 0, 0.3)'}"
                 :show="showContactPicker">
      <div class="contact_select_wrap">
        <div class="contact_select_header">
          <van-icon name="arrow-left" @click="handleClickContactPickerClose"></van-icon>
          <span class="title">选择成员</span>

        </div>
        <el-input ref="contactNameInput"
                  v-model="contactName"
                  clearable
                  placeholder="请输入"
                  prefix-icon="el-icon-search"
                  size="small"
                  @blur="getUserOptions(contactName)"
                  @clear="getUserOptions"
                  @keyup.enter.native="handleContactKeywordInputEnter"></el-input>
        <ul class="contact_select_list">
          <li v-for="item in userOptions"
              class="contact_select_item"
              @click="handleClickContactItem(item)">
            <span class="avatar_wrap">
                 <img :src="item.avatar?item.avatar:defaultImg" alt="">
            </span>
            <span v-text="item.name"></span>
          </li>
        </ul>
      </div>
    </van-overlay>
  </van-popup>
</template>
<script>
import {GetUserList, orderMemberAdd} from "@/api";

export default {
  name: "OrderAddMember",
  data() {
    return {
      teamMembersAddForm: {
        member_uid: '',
        member_user: '',
        auth: 1
      },
      teamMembersAddFormRules: {
        member_uid: [
          {
            required: true,
            trigger: 'onChange',
            message: '请选择成员',
            validator: (value) => {
              return value !== ''
            }
          },
        ]
      },
      userOptions: [],
      showContactPicker: false,
      contactName: '',
      defaultImg: require('@/assets/images/default.jpg'),
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    order_ids: {
      type: Array,
      default: () => []
    }
  },
  created() {

  },
  methods: {
    //获取用户列表
    getUserOptions(keyword) {
      GetUserList({keyword}).then(res => {
        if (res.code === 200) {
          this.userOptions = res.data || []
        } else {
          this.$toast(res.message)
        }
      })
    },

    // 关闭弹窗
    handleDialogClose() {
      this.$emit('update:dialogVisible', false)
    },

    //点击选择成员
    handleClickSelectMember() {
      if (this.userOptions.length === 0) {
        this.getUserOptions()
      }
      this.showContactPicker = true
    },

    //联系人搜索框回车事件
    handleContactKeywordInputEnter() {
      this.$refs.contactNameInput.blur()
    },

    //联系人选择弹窗关闭事件
    handleClickContactPickerClose() {
      this.contactName = ''
      this.showContactPicker = false
    },

    handleClickContactItem(item) {
      this.teamMembersAddForm.member_uid = item.uid
      this.teamMembersAddForm.member_user = item.name
      this.handleClickContactPickerClose()
    },

    // 确定
    handleDialogConfirm() {
      this.$refs.teamMembersAddForm.validate().then(() => {
        orderMemberAdd({
          order_ids: this.order_ids,
          member_uid: this.teamMembersAddForm.member_uid,
          auth: this.teamMembersAddForm.auth
        }).then(res => {
          if (res.code === 200) {
            this.$toast.success('添加成功')
            this.$emit('update:dialogVisible', false)
            this.$emit('refresh')
          }
        })
      }).catch(error=>{
        if(error){
          this.$toast.fail(error[0].message)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.contact_select_wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  position: absolute;
  bottom: 0;
  border-radius: 8px 8px 0 0;
  padding: 12px 16px;

  .contact_select_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    .van-icon-arrow-left {
      font-size: 24px;
    }

    .title {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      color: #333333;
    }
  }

  .contact_select_list {
    overflow-y: auto;
    flex: 1;
    margin-top: 10px;
    max-height: calc(100% - 78px);

    .contact_select_item {
      padding: 8px 0;
      display: flex;
      align-items: center;
      gap: 12px;

      .avatar_wrap {
        display: inline-block;
        width: 28px;
        height: 28px;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>